module.exports = __webpack_public_path__ + "img/labmem_text_title_sc.01f8e50f.png";